import * as Actions from 'reducks/coupon/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const CouponReducer = (state = initialState.coupon, action: any) => {
  switch (action.type) {
    case Actions.CONFIRM_COUPON:
      return {
        ...state,
        confirm: { ...action.payload },
      }
    case Actions.FETCH_COUPONS:
      return {
        ...state,
        confirm: initialState.coupon.confirm, // 詳細画面と登録画面を行き来する際の値をリセットするため
        coupons: [...action.payload],
      }
    case Actions.INIT_COUPONS:
      return {
        ...initialState.coupon,
      }
    default:
      return state
  }
}
